var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",attrs:{"id":"landing-top"}},[_c('article',{staticClass:"container-fluid"},[_c('section',{staticClass:"container"},[_c('div',{staticClass:"jumbotron"},[_c('m-hero'),_vm._v(" "),_c('m-user-data')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20fad62c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MV2.vue
// module id = null
// module chunks = 